import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';

import BrainIcon from '../icons/brain.svg?react';
import ChevronDownIcon from '../icons/chevrondown.svg?react';
import Spinner from '../Spinner.jsx';
import MarkdownRenderer from './MarkdownRenderer.jsx';

const ThinkingPart = ({ thinking, duration, isStreaming = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldReduceMotion = useReducedMotion();

  if (!thinking?.length) return null;

  const inProgress = isStreaming && duration == null;
  const headerText = duration != null
    ? `Thought for ${duration.toFixed(2)}s`
    : 'Thinking';

  return (
    <div
      className="bg-bg-thinking rounded-lg p-spacing-2 w-full hover:cursor-pointer group"
      onClick={() => setIsExpanded(v => !v)}
      role="button"
      tabIndex={0}
      aria-expanded={isExpanded}
      aria-label="Toggle thinking details"
    >
      <div className="flex items-center w-full text-secondary">
        <span className="text-dls-body flex items-center gap-spacing-2 group-hover:text-primary">
          {inProgress
            ? <Spinner size="xs" color="text-secondary" />
            : <BrainIcon className="size-[14px] flex-shrink-0" />
          }
          {headerText}
        </span>
        <span className="ml-auto group-hover:text-primary" aria-hidden="true">
          <ChevronDownIcon className={`size-[14px] transition-transform duration-300 ${isExpanded ? 'rotate-0' : '-rotate-90'}`} />
        </span>
      </div>

      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={shouldReduceMotion ? false : { opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: shouldReduceMotion ? 0 : 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <div className="pt-spacing-2 text-dls-body text-secondary">
              <MarkdownRenderer content={thinking} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

ThinkingPart.propTypes = {
  thinking: PropTypes.string,
  duration: PropTypes.number,
  isStreaming: PropTypes.bool,
};

export default ThinkingPart;
